import { useNavigate } from "react-router-dom";

const COMPANY = [
  ["About Us", "/about", "footer-about"],
  ["Features", "/features", "footer-features"],
  ["Pricing", "/pricing", "footer-pricing"],
  ["Marketplace", "/marketplace", "footer-marketplace"],
  ["FAQs", "/faq", "footer-faq"],
  ["Contact Us", "/contact", "footer-contact"],
  ["Sign in", "/login", "footer-signin"],
  ["Start free", "/register", "footer-start-free"],
];
const COMPLIANCE = [
  ["Disclaimer", "/disclaimer", "footer-legal-disclaimer"],
  ["Terms of Service", "/terms", "footer-legal-terms"],
  ["Privacy Policy", "/privacy", "footer-legal-privacy"],
  ["Cookies Policy", "/cookies", "footer-legal-cookies"],
  ["Accessibility", "/accessibility", "footer-legal-accessibility"],
  ["Acceptable Use Policy", "/acceptable-use", "footer-legal-acceptable-use"],
];

const linkStyle = { cursor: "pointer", fontSize: 13, color: "var(--muted)" };
const colHead = { fontWeight: 700, fontSize: 13, color: "var(--heading)", marginBottom: 4 };

export default function PublicFooter() {
  const nav = useNavigate();
  return (
    <footer data-testid="public-footer"
      style={{ padding: "48px 0 40px", marginTop: 48 }}>
      <div className="k-footer-accent" style={{ margin: "0 auto 28px" }} />
      <div style={{ margin: "0 auto", padding: "0 24px" }}>
        {/* Top row: nav columns on the left, About/description block on the right */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 56, justifyContent: "space-between", alignItems: "flex-start" }}>
          {/* Navigation columns */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 56 }}>
            <div data-testid="footer-company" style={{ display: "flex", flexDirection: "column", gap: 9, minWidth: 150 }}>
              <div className="k-heading" style={colHead}>Company</div>
              {COMPANY.map(([label, to, tid]) => (
                <a key={to} className="k-link" data-testid={tid} onClick={() => nav(to)} style={linkStyle}>{label}</a>
              ))}
            </div>
            <div data-testid="footer-compliance" style={{ display: "flex", flexDirection: "column", gap: 9, minWidth: 150 }}>
              <div className="k-heading" style={colHead}>Compliance</div>
              {COMPLIANCE.map(([label, to, tid]) => (
                <a key={to} className="k-link" data-testid={tid} onClick={() => nav(to)} style={linkStyle}>{label}</a>
              ))}
            </div>
          </div>

          {/* About block (moved to the right, next to the Compliance column) */}
          <div data-testid="footer-about-block" style={{ flex: "1 1 380px", maxWidth: 520 }}>
            <div className="k-heading" style={{ fontWeight: 700, fontSize: 15, letterSpacing: "-.01em" }}>
              The world is local.
            </div>
            <p className="k-muted" style={{ fontSize: 13, lineHeight: 1.7, marginTop: 10 }}>
              Kadana is an Enterprise Autonomous Compliance and Localization Orchestrator (EACLO). Powered
              by our patent-pending BeCo Index
              <a data-testid="footer-patent-asterisk" onClick={() => nav("/ai-transparency")}
                style={{ cursor: "pointer", color: "var(--accent-primary)", textDecoration: "none" }}>*</a>
              {" "}(a guide comparing your prompt's clarity to your app's complexity, not a payment or fraud
              tool), Kadana turns natural language prompts into production-ready web, iOS and Android
              applications, with ready-made building blocks for local payment rails, regional tax engines,
              and regulatory frameworks — connected using your own credentials. Software is borderless;
              Kadana helps you make it compliance-ready, market by market, starting with UK and EU
              compliance-readiness by default.
            </p>
            <p className="k-muted" data-testid="footer-patent-note" style={{ fontSize: 12, marginTop: 8 }}>
              *Patent application filed, Kenya, 13 September 2026.{" "}
              <a className="k-patent-asterisk" data-testid="footer-patent-link" onClick={() => nav("/ai-transparency")}
                style={{ cursor: "pointer" }}>See our AI Transparency Notice.</a>
            </p>
          </div>
        </div>

        {/* Legal disclaimer */}
        <div data-testid="footer-disclaimer" style={{ marginTop: 34, borderTop: "1px solid var(--border)", paddingTop: 20 }}>
          <p className="k-muted" style={{ fontSize: 11.5, lineHeight: 1.7, margin: 0 }}>
            <strong style={{ color: "var(--heading)", fontWeight: 700 }}>LEGAL DISCLAIMER:</strong> Kadana is owned and
            operated by Melian Dialogue Limited (Company Number PVT-27ULY98K) (trading as Kadana). Kadana operates strictly as an agentic
            software engineering framework, technical proxy engine, and cloud runtime environment. Kadana is not a bank,
            electronic money institution, licensed payment service provider, merchant of record (MoR), legal practice, or
            tax advisory firm. The platform does not hold, handle, clear, or settle client funds, nor does it provide formal
            legal, financial, or tax advice. All financial transactions are processed directly via user-configured
            third-party credentials.
          </p>
          <p className="k-muted" style={{ fontSize: 11.5, lineHeight: 1.7, marginTop: 10 }}>
            AI-generated source code, autonomous compliance updates (Watchdogs), and platform telemetry are provided on an
            "AS IS" basis. Users are strictly obligated to independently review, test, and verify all generated code and tax
            configurations with qualified legal and financial counsel prior to live commercial deployment. See our full{" "}
            <a className="k-link" onClick={() => nav("/disclaimer")} style={{ cursor: "pointer" }}>Disclaimer</a>,{" "}
            <a className="k-link" onClick={() => nav("/terms")} style={{ cursor: "pointer" }}>Terms of Service</a>, and{" "}
            <a className="k-link" onClick={() => nav("/privacy")} style={{ cursor: "pointer" }}>Privacy Policy</a> for
            complete detail.
          </p>
        </div>

        {/* Copyright */}
        <p className="k-muted" data-testid="footer-copyright" style={{ fontSize: 11.5, marginTop: 20 }}>
          © 2026 Melian Dialogue Limited trading as Kadana.
          {"  "}
          <a data-testid="footer-cookie-settings" className="k-patent-asterisk" style={{ cursor: "pointer" }}
            onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))}>Cookie settings</a>
        </p>
      </div>
    </footer>
  );
}
